// extracted by mini-css-extract-plugin
export default {"main":"Deck_main__ekigT","card":"Deck_card__FmUsv"};